import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import timeinterval from './common/js/timeinterval.js';
import ElementUI from 'element-ui'
import './styles.scss'
import './common/css/common.scss';
import './common/css/eleui.scss';
import './common/iconfont/iconfont.css'
import './common/iconfont/iconfont.js'
import './directives/cursorpoint.js'
import './directives/number.js'
import axios from './common/utils/request.js'

Vue.use(ElementUI)
Vue.config.productionTip = false;

Vue.prototype.$TM=timeinterval;
Vue.prototype.$axios=axios;
Vue.prototype.$store=store;
import VueClipboard from 'vue-clipboard2'

VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)
var _Vue=new Vue({
  router,
  store,
  render: (h) => h(App),
    data(){
    return{
        mobileformat: /^1[34578]\d{9}$/,
        pageSizes:[10,20,50,100]
    }
    },
    directives:{

    },
    methods:{
        getStorage(name){
            return JSON.parse(localStorage.getItem(name));
        },
        setStorage(name,data){
            var a=JSON.stringify(data)
            localStorage.setItem(name,a);
        },
        removeStorage(name){
            localStorage.removeItem(name);
        },


        //客户来源
        getuserFrom(){
            // this.$axios.post("/dic/userFromCode",{
            //     "parentId": "1001",
            //     "dicType": "user_from_code"
            // }).then(res=>{
            //     return res.data.list;
            // }).catch(err=>{
            //     this.$message.error(err.msg);
            // })
            return [{
                "dicCode": "01",
                "dicName": "美团"
            },
                {
                    "dicCode": "02",
                    "dicName": "大众点评"
                },
                {
                    "dicCode": "03",
                    "dicName": "百度"
                }]
        },
        //意向场地
        gethouseList(){
            // this.$axios.post("/config/houseListByStoreId",{
            //     "storeId": "1001"
            // }).then(res=>{
            //     return res.data.list;
            // }).catch(err=>{
            //     this.$message.error(err.msg);
            // })
            return [{
                "houseNo": "100101",
                "houseName": "辉煌厅"
            },
                {
                    "houseNo": "100102",
                    "houseName": "刺激厅"
                },
                {
                    "houseNo": "100103",
                    "houseName": "英雄厅"
                }]
        },


        //获取店铺列表
        getstoreList(){
            // this.$axios.post("/dic/orderStateCode").then(res=>{
            //     return res.data.list;
            // }).catch(err=>{
            //     this.$message.error(err.msg);
            // })
            return  [
                {
                    "storeName": "奥创轰趴",
                    "storeId": "002"
                },
                {
                    "storeName": "美队轰趴",
                    "storeId": "2"
                }]
        },
        //只许输入数字
        onlyNumber(mobile){
            return mobile.replace(/[^\d]/g, '')
        },
        //只允许输入正整数
        inputNumber(num,decimal=0){
            var data=num;
            if(decimal!=0) {
                data = data.replace(/[^\d.]/g,"");  //清除“数字”和“.”以外的字符
                data = data.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
                data = data.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
                var test = '/^(\\-)*(\\d+)\.(\\d{' + decimal + '}).*$/';
                console.log(test)
                data = data.replace(eval(test), '$1$2.$3');//只能输入几个小数
            }else{
                data = data.replace(/[^\d]/g,"");//清除“数字”以外的字符
            }
            if(data.indexOf(".")< 0 && data !=""){//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
                data= parseFloat(data);
            }
            return data;
        },
    },
}).$mount('#app');
export  default _Vue;